// переменные окружения (см. webpack.*.js)
export const URL_SERVER = process.env.URL_SERVER;
export const UI_VERSION = process.env.BUILD_VERSION;
export const UI_BUILD_NUMBER = process.env.BUILD_NUMBER;
